module.exports = __webpack_public_path__ + "resources/img/logo_nhn_godo.031023ee35bf55a6f610dd68986000f3.png";